import ENV from "config/Env";
import { useTypedMutation } from "hooks";
import { ApiInstance } from "utils/Api";

type TestUserPayload = {
  user_id: number;
  dealer_location_id: number;
  active: boolean;
  has_leased_tablet: boolean;
  is_combi_user: boolean;
  is_counter_tablet_user: boolean;
  dealer_name?: string;
  dealer_id?: number;
  location_name?: string;
  username?: string;
  email?: string;
  first_name?: string;
  last_name?: string;
  role?: number;
  web_version?: string;
  app_version?: string;
  last_login?: string;
};

type TestWebhookPayload = {
  payload: {
    appointment_id?: number;
    communication_key: string;
    customer_dms_nr: string;
    customer_type: string;
    dealer_location_id: number;
    wo_nr: string;
    dealer_id: number;
    webhook_trigger_id: number;
    user?: TestUserPayload;
  };
  webhook_id: number;
};

export const useTestWebhookMutation = () =>
  useTypedMutation({
    mutationFn: async (payload: TestWebhookPayload) => (await ApiInstance.post(`/webhooks/test`, payload, ENV.dealerBaseURL)).data,
    onSuccess: () => null
  });
